/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Verb_Task_ReopenedInputs */

const en_case_history_verb_task_reopened = /** @type {(inputs: Case_History_Verb_Task_ReopenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reopened`)
};

const pt_br2_case_history_verb_task_reopened = /** @type {(inputs: Case_History_Verb_Task_ReopenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reaberta`)
};

/**
* | output |
* | --- |
* | "reopened" |
*
* @param {Case_History_Verb_Task_ReopenedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_verb_task_reopened = /** @type {((inputs?: Case_History_Verb_Task_ReopenedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Verb_Task_ReopenedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_verb_task_reopened(inputs)
	return pt_br2_case_history_verb_task_reopened(inputs)
});